module.exports = __webpack_public_path__ + "img/mood-bad.666ae357.svg";